/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid, makeStyles, Tooltip } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-fetching-library';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { ActivePatientContext } from '../../../contexts/ActivePatientProvider';
import useMetadataUpdate from '../../../hooks/useMetadataUpdate';
import { getLocalizedDate } from '../../../helpers/localize';
import { formatPhoneForInfoPanel } from '../../../helpers/phone';
import {
  openPatientPane,
} from '../../../redux_store/reducer/reducers/infoPaneReducer';
import LoadingErrorWidget from '../../Shared/LoadingErrorWidget';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const useStyles = makeStyles((theme) => ({
  dot: {
    padding: theme.spacing(0, 0.5),
    color: theme.colors.lightBlue,
  },
  patientInfoBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginTop: 12,
  },
  titleTextBox: {
    display: 'flex',
    maxHeight: 35,
    maxWidth: 700,
    paddingTop: 8,
    width: '100%',
    minWidth: 200,
    alignItems: 'flex-start',
    flexDirection: 'column',

    '@media print': {
      display: 'none',
    },
  },
  patientData: {
    display: 'flex',
  },
  patientName: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 10,
    background: 'transparent',
    transition: '.3s',
    fontSize: 16,
    fontWeight: 500,

    '&:hover': {
      transition: '.3s',
      color: '#0073b0',
    },
  },
  infoIcon: {
    width: 16,
    marginLeft: 4,
    color: '#868686',
  },
}));

const PatientInfoBlock = ({ patientUUID, onSecondStyleClick }) => {
  const classes = useStyles();
  const {
    patientUuid: paramsPatientUuid,
    accountUuid: paramAccountUuid,
  } = useParams();
  const [apiError, setError] = useState(false);
  const dispatch = useDispatch();
  const { en: { infoPane } } = useSelector((state) => state.i18n);
  const {
    patientUuid,
    patientInfo,
    setPatientUuid,
    setPatientInfo,
  } = useContext(ActivePatientContext);
  const {
    metadata: {
      currentAccount,
    },
  } = useSelector((state) => state.user);

  const { query, error, loading } = useMetadataUpdate(useQuery, [
    {
      method: 'GET',
      endpoint: `/accounts/${paramAccountUuid || currentAccount.uuid}/patients/${
        patientUUID || paramsPatientUuid
      }`,
    },
    false,
  ]);

  const getData = () => {
    setError(false);
    query().then(({ error, payload }) => {
      if (!error) {
        setPatientUuid(patientUUID || paramsPatientUuid);
        setPatientInfo({
          ...payload,
          dateOfBirth: getLocalizedDate(payload.dateOfBirth, 'UTC'),
          phone: formatPhoneForInfoPanel(
            payload.phone != null ? payload.phone.phone : '',
          ),
        });
      } else {
        setError(true);
      }
    });
  };

  useEffect(() => {
    const hasParamsAccountUuid = !!(paramAccountUuid || currentAccount.uuid);
    const hasPropsPatientUUID = !!patientUUID;
    const hasParamsPatientUUID = !!paramsPatientUuid;
    const hasPagePatientUUID = hasPropsPatientUUID || hasParamsPatientUUID;
    const patientUuidDontMatch = patientUUID
      ? patientUuid !== patientUUID || patientInfo?.uuid !== patientUUID
      : patientUuid !== paramsPatientUuid || patientInfo?.uuid  !== paramsPatientUuid;
    const hasEnoughInfoForRequest = hasParamsAccountUuid && hasPagePatientUUID;
    const shouldMakeRequest = patientUuidDontMatch || !patientInfo;

    if (hasEnoughInfoForRequest && shouldMakeRequest) {
      if (patientInfo) setPatientInfo(undefined);
      getData();
    }
  }, [patientUuid, paramsPatientUuid, patientUUID]);

  if (onSecondStyleClick) {
    if (onSecondStyleClick) {
      return (apiError || error) && !loading ?
        <LoadingErrorWidget onReload={getData} /> : !patientInfo || !patientInfo?.lastName
          ? <Skeleton variant='text' width={150} />
          : patientInfo
            ? <div style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip
                enterNextDelay={800}
                title={infoPane.clickToOpenInfoPane}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className={classes.patientName}
                       onClick={onSecondStyleClick}
                  >
                    {`${patientInfo.lastName}, ${patientInfo.firstName}`}
                    <InfoOutlinedIcon className={classes.infoIcon} />
                  </div>
                </div>
              </Tooltip>
              <div style={{ margin: '0 12px' }}>{'•'}</div>
              <div>
                {`${patientInfo.dateOfBirth}`}
              </div>
            </div>
            : <></>;
    }
    return (apiError || error) && !loading ? <LoadingErrorWidget onReload={getData} /> : <></>;
  }


  return (apiError || error) && !loading ?
    <LoadingErrorWidget onReload={getData} /> : patientInfo && patientInfo?.dateOfBirth && patientInfo?.lastName
      ? <div className={classes.patientInfoBox}>
        <span key={patientInfo.dateOfBirth}
              className={classes.patientData}
        >
          {patientInfo.dateOfBirth}
        </span>
        <Button
          variant={'outlined'}
          color={'primary'}
          onClick={() => dispatch(openPatientPane({
            patientUUID: patientInfo.uuid,
            accountUUID: paramAccountUuid || currentAccount.uuid,
            patientFirstName: patientInfo.firstName,
            patientLastName: patientInfo.lastName,
          }))}
          style={{ padding: '0px 6px' }}
        >
          {infoPane.moreDetails}
        </Button>
      </div>
      : <Grid item className={classes.titleTextBox}>
        <div style={{ width: '50%' }}><Skeleton variant='text' /></div>
        <div style={{ width: '80%' }}><Skeleton variant='text' /></div>
      </Grid>;
};

PatientInfoBlock.propTypes = {
  patientUUID: PropTypes.string,
};

PatientInfoBlock.defaultProps = {
  patientUUID: null,
};

export default PatientInfoBlock;
